import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { ORDER_STATUS_DELIVERING } from 'Constants/Order/Order.constants'
import StyledHourglassFullIconComponent from 'Components/OrderDetailsHeader/StyledHourglassFullIcon.component'
import cn from 'classnames'
import { Button } from '@material-ui/core'
import ControlPointDuplicateIcon from '@material-ui/icons/ControlPointDuplicate'
import { useDispatch } from 'react-redux'
import hitGTM from 'State/Store/UI/Actions/GTM.action'
import { UI_PLUS_LOAD_DELIVERY_PANE_GET_BTN } from 'State/Store/UI/UI.types'
import { shouldShowPlusLoad } from 'Components/OrderDetailsHeader/parts/utils/should-show-plus-load'
import { Order, PlusLoadStatus } from 'types/Order'
import { formatPlusLoadQuantityTextByStatus } from 'ui-format-utils.ts/format-plus-load-quantity-text-by-status'
import { UI_TEXT_GET_A_PLUS_LOAD } from 'ui-format-utils.ts/ui-text/get-a-plus-load'
import ServicesContext from 'Contexts/Services/Services.context'
import { checkThenOpenPlusLoadModal } from 'Components/OrderDetailsHeader/utils/check-then-open-plus-load-modal'
import moment from 'moment'
import { OrderStatus } from 'types/OrderStatus'

interface Props {
  classes: any,
  currentOrder: Order,
  normalizedDetails: any,
  callBoral: any,
  currentDeliveryDetails?: any,
}

const GraphLegend = (props: Props) => {
  const {
    classes,
    currentOrder,
    normalizedDetails,
    currentDeliveryDetails,
  } = props
  const dispatch = useDispatch()
  const services = useContext(ServicesContext)
  const renderArrived = () => {
    // (currentOrder.summary.status === ORDER_STATUS_DELIVERING || currentOrder.summary.status === ORDER_STATUS_COMPLETED)
    //     && normalizedDetails.delivered.loadQty
    let num = Number(normalizedDetails.delivered.loadQty || 0)
    let truckNum = normalizedDetails.delivered.noOfTrucks || 0

    if (isTodayOrder(currentOrder)) {
      num = Number(currentDeliveryDetails.data.orders.totalDelivered || 0);
      truckNum = currentDeliveryDetails.data.orders.loads && currentDeliveryDetails.data.orders.loads.delivered ? currentDeliveryDetails.data.orders.loads.delivered.length : 0;
    }

    const muted = num === 0
    return (
      <Grid item xs={12} className={classes.marginBottom1unit}>
        <div className={classes.legendContainer}>
          <Typography className={classes.dotCopy} variant='subtitle2'>
            <span className={classes.arrivedDot}>&nbsp;</span>
            <span className={classes.lineheight16}>Arrived</span>
          </Typography>
        </div>

        <Typography variant='h6' className={cn(classes.qtyText, { [classes.mutedText]: muted })}>
          {`${num.toFixed(1)} m³`}
        </Typography>

        <Typography variant='body2' className={cn({ [classes.mutedText]: muted })}>
          {`${truckNum} Truck${truckNum === 1 ? `` : `s`}`}
        </Typography>
      </Grid>
    )
  }
  const renderInTransit = () => {
    // if (currentOrder.summary.status === ORDER_STATUS_DELIVERING) {
    //  && normalizedDetails.inTransit.loadQty ? (
    let num = Number(normalizedDetails.inTransit.loadQty || 0)

    let truckNum = normalizedDetails.inTransit.noOfTrucks || 0
    if (isTodayOrder(currentOrder)) {
      num = Number(currentDeliveryDetails.data.orders.totalIntransit || 0);
      truckNum = currentDeliveryDetails.data.orders.loads && currentDeliveryDetails.data.orders.loads.intransit ? currentDeliveryDetails.data.orders.loads.intransit.length : 0;
    }

    const muted = num === 0
    return (
      <Grid item xs={12} className={classes.marginBottom1unit}>
        <div className={classes.legendContainer}>
          <Typography className={classes.dotCopy} variant='subtitle2'>
            <span className={classes.inTransitDot}>&nbsp;</span>
            <span className={classes.lineheight16}>In Transit</span>
          </Typography>
        </div>

        <Typography variant='h6' className={cn(classes.qtyText, { [classes.mutedText]: muted })}>
          {`${num.toFixed(1)} m³`}
        </Typography>

        <Typography variant='body2' className={cn({ [classes.mutedText]: muted })}>
          {`${truckNum} Truck${truckNum === 1 ? `` : `s`}`}
        </Typography>
      </Grid>
    )
  }
  const renderToGo = () => {
    if (!currentOrder.details) {
      return null
    }

    let num =
      currentOrder.summary.status !== ORDER_STATUS_DELIVERING
        ? Number(currentOrder.details.qty.ordered || 0)
        : Number(normalizedDetails.scheduled.loadQty || 0);

    let truckNum = getToGoNumber(currentOrder, normalizedDetails.scheduled.noOfTrucks)
    if (
      isTodayOrder(currentOrder) &&
      (currentOrder.summary.status === OrderStatus.ORDER_STATUS_COMPLETED ||
        currentOrder.summary.status === OrderStatus.ORDER_STATUS_ON_HOLD ||
        currentOrder.summary.status === OrderStatus.ORDER_STATUS_DELIVERING)
    ) {
      num = Number(currentDeliveryDetails.data.orders.totalScheduled || 0);
      truckNum = currentDeliveryDetails.data.orders.loads && currentDeliveryDetails.data.orders.loads.scheduled.length ? currentDeliveryDetails.data.orders.loads.scheduled.length : 0;
    }

    const muted = num === 0
    return (
      <Grid item xs={12} className={classes.marginBottom1unit}>
        <div className={classes.legendContainer}>
          <Typography className={classes.dotCopy} variant='subtitle2'>
            <span className={classes.toGoDot}>&nbsp;</span>
            <span className={classes.lineheight16}>To Go</span>
            {
              currentOrder.details.isPendingModification
              && currentOrder.details.modifyFields
              && 'quantity' in currentOrder.details.modifyFields
              && (
                <div className={cn(classes.marginLeft1unit, classes.displayInlineBlock)}>
                  <StyledHourglassFullIconComponent />
                </div>
              )
            }
          </Typography>
        </div>

        <Typography variant='h6' className={cn(classes.qtyText, { [classes.mutedText]: muted })}>
          {`${num.toFixed(1)} m³`}
        </Typography>

        <Typography variant='body2' className={cn({ [classes.mutedText]: muted })}>
          {`${truckNum} Truck${truckNum === 1 ? `` : `s`}`}
        </Typography>

      </Grid>
    )
  }
  const handlePlusLoadClick = async () => {
    dispatch(hitGTM(UI_PLUS_LOAD_DELIVERY_PANE_GET_BTN))
    checkThenOpenPlusLoadModal({
      services,
      dispatch,
      order: currentOrder,
    })
  }

  const renderPlusLoad = () => {
    const showPlusLoad = shouldShowPlusLoad(currentOrder)
    const showSubmitted = currentOrder.details.plusLoadDetails && currentOrder.details.plusLoadDetails.status === PlusLoadStatus.SUBMITTED
    const showApplied = currentOrder.details.plusLoadDetails && currentOrder.details.plusLoadDetails.status === PlusLoadStatus.APPLIED
    return (
      <Grid item xs={12} className={classes.marginBottom1unit}>
        <div className={classes.legendContainer}>
          {<Typography className={cn(classes.dotCopy, classes.marginBottom1unit)} variant='subtitle2'>
            <span className={cn(classes.plusLoadDot, {
              [classes.plusLoadDotSubmittedOrApplied]: showSubmitted || showApplied,
            })}>&nbsp;</span>Plus Load
          </Typography>}
          { showSubmitted && showPlusLoad
            && (
              <Typography className={cn(classes.marginBottom1unit)} variant='body1'>
                { formatPlusLoadQuantityTextByStatus(currentOrder.details.plusLoadDetails.qty, currentOrder.details.plusLoadDetails.status as PlusLoadStatus.SUBMITTED) }
              </Typography>
            )
          }
          {showApplied && showPlusLoad
            && (
              <Typography className={cn(classes.marginBottom1unit)} variant='body1'>
                { formatPlusLoadQuantityTextByStatus(currentOrder.details.plusLoadDetails.qty, currentOrder.details.plusLoadDetails.status as PlusLoadStatus.APPLIED) }
              </Typography>
            )
          }
          {showPlusLoad && <Button className={classes.boxShadow0} variant='contained' size='small' onClick={handlePlusLoadClick}>
            <ControlPointDuplicateIcon className={classes.iconLeft} />
            { UI_TEXT_GET_A_PLUS_LOAD }
          </Button>}
        </div>
      </Grid>
    )
  }

  return (
    <Grid
      key='plus-load-container'
      container
      alignItems='flex-start'
      className={classes.textAlignLeft}
      spacing={1}
    >
      { renderArrived() }
      { renderInTransit() }
      { renderToGo() }
      { renderPlusLoad() }
    </Grid>
  )
}

const isTodayOrder = (order: Order) => {
  const startTime = order.summary.startTime.replace(`.`, `:`)
  return moment()
    .startOf(`day`)
    .isSame(moment(startTime).startOf(`day`));
}

function getToGoNumber(order: Order, scheduledNoOfTrucks: number) {
  if (isTodayOrder(order)) {
    if (order.summary.status === OrderStatus.ORDER_STATUS_TO_BE_CONFIRMED || order.summary.status === OrderStatus.ORDER_STATUS_CANCELLED) {
      return order.details.numberOfScheduledTrucks
    }
    return scheduledNoOfTrucks || 0
  } else {
    if (order.summary.status === OrderStatus.ORDER_STATUS_NEW) {
      return 0
    }
    return order.details.numberOfScheduledTrucks
  }
}
export default GraphLegend
